import { useEffect, useState } from "react";
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { AdminPasswordModal } from './components/AdminPasswordModal';
import Main from './pages/Main';
import UseTimeDetail from './pages/UseTimeDetail';
import ShowMeTheMoney from './pages/ShowMeTheMoney';
import ShowMeTheNeso from './pages/ShowMeTheNeso';
import UseTime from './pages/UseTime';
import AdminDashboard from "./pages/AdminDashboard";
import StigmaStatus from "./pages/StigmaStatus";
import api from './api';

export default function App() {
  // 페이지를 결정하는 플래그 (현재 페이지)
  const [currentPage, setCurrentPage] = useState('main'); // 기본값은 'main'
  const [host, setHostname] = useState('');
  const [description, setDescription] = useState('');
  const [showAdminModal, setShowAdminModal] = useState(false);

  const handleAdminLogin = async (password) => {
    try {
      const response = await api.get(`/getAdminCookie?key=${password}`, { withCredentials: true });
      if (response.data === "valid") {
        setShowAdminModal(false);
        setCurrentPage("adminPortal");
        // 성공 메시지는 모달이 닫힌 후 표시될 수 있도록 setTimeout 사용
        setTimeout(() => {
          // 필요하다면 성공 토스트 메시지 추가 가능
        }, 100);
      } else {
        // 실패시 에러를 throw하여 모달에서 처리하도록 함
        throw new Error("관리자키를 확인해주세요.");
      }
    } catch (error) {
      console.error(error);
      throw new Error("오류가 발생했습니다. 관리자키를 확인해주세요.");
    }
  };

  const handleAdminModalClose = () => {
    setShowAdminModal(false);
    setCurrentPage('main');
  };

  useEffect(() => {
    if (currentPage == "tryAdmin") {
      setShowAdminModal(true);
    }
  }, [currentPage]);

  useEffect(() => {
    if (currentPage == "main") {
      setDescription("메인페이지");
    } else if (currentPage == "useTimeDetail") {
      setDescription("커미션 명세서");
    } else if (currentPage == "showMeTheMoney") {
      setDescription("실시간 수입");
    } else if (currentPage == "showMeTheNeso") {
      setDescription("실시간 네소 확인");
    } else if (currentPage == "useTime") {
      setDescription("PC 사용시간 순위");
    } else if (currentPage == "stigmaStatus") {
      setDescription("찍 상태 확인");
    } else if (currentPage == "adminPortal") {
      setDescription("관리자 페이지");
    }
  }, [currentPage])

  // 페이지 변경 함수
  const changePage = (page) => {
    setCurrentPage(page);
  };
  // 페이지 변경 함수
  const setHost = (name) => {
    setHostname(name);
  };

  return (
    <div style={{
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      minHeight: '100vh',
      width: '100%'
    }}>
      {/* 헤더 완전 제거 */}
      
      {/* 중간 내용은 currentPage 상태에 따라 조건부 렌더링 */}
      <main>
        {currentPage === 'main' && <Main host={host} setHost={setHost} changePage={changePage} />}
        {currentPage === 'useTimeDetail' && <UseTimeDetail host={host} changePage={changePage} />}
        {currentPage === 'showMeTheMoney' && <ShowMeTheMoney host={host} changePage={changePage} />}
        {currentPage === 'showMeTheNeso' && <ShowMeTheNeso host={host} changePage={changePage} />}
        {currentPage === 'useTime' && <UseTime changePage={changePage} />}
        {currentPage === 'stigmaStatus' && <StigmaStatus host={host} changePage={changePage} />}
        {currentPage === 'adminPortal' && <AdminDashboard changePage={changePage} />}
      </main>

      <Footer changePage={changePage}/>
      
      {/* Admin Password Modal */}
      <AdminPasswordModal
        visible={showAdminModal}
        onClose={handleAdminModalClose}
        onSubmit={handleAdminLogin}
      />
    </div>
  );
}